<procure-card
  class="kpi-widget"
  [class.light]="light()"
  [class.compact]="compact()"
  [loading]="isLoading()"
  [loadingDiameter]="loadingDiameter()"
>
  <h3
    class="kpi-value"
    data-testid="kpi"
    [class.empty]="isEmpty()"
  >
    {{ kpi() }}
  </h3>
  <div
    class="kpi-label"
    data-testid="label"
  >
    {{ label() }}
  </div>
  <div class="kpi-content">
    <ng-content />
  </div>
</procure-card>
